module.exports = "/_next/static/images/R18-a655db4b3e0ce0c2e44b897a6545e0ec.png";